// extracted by mini-css-extract-plugin
export default {"table":"on-account-change_table__qbYpc","button-wrapper":"on-account-change_button-wrapper__xdahq","buttonWrapper":"on-account-change_button-wrapper__xdahq"};